if (!customElements.get('top-bar')) {
  customElements.define('top-bar', class TopBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log('top-bar loaded');
      let _this = this;
      this.initializeSlider();
      /*window.addEventListener('resize', _this.initializeSlider());*/
    }

    initializeSlider() {
      let $slider  = $('.top-bar__slider');
      if($slider.hasClass('slick-initialized')) {
        $slider.slick('refresh');
        return false;
      } else {
        $slider.slick({
          autoplay: true,
          autoplaySpeed: 5000,
          dots: false,
          arrows: false,
          draggable: true,
          infinite: true,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 0
        })
      }
    }
  })
}
